/**
 * Living Library — public API helpers.
 * Thin fetch wrappers; the category catalogue lives in libraryCategories.js
 * and must stay in sync with LIBRARY_CATEGORIES in backend/library_service.py.
 */
const API = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "");

export async function fetchLibraryOverview() {
  const res = await fetch(`${API}/api/library/overview`);
  if (!res.ok) throw new Error("library overview failed");
  return res.json();
}

export async function fetchCategoryEntries(categoryId) {
  const res = await fetch(`${API}/api/library/categories/${categoryId}/entries`);
  if (!res.ok) throw new Error("library category failed");
  return res.json();
}

export async function searchLibrary(q) {
  const res = await fetch(`${API}/api/library/search?q=${encodeURIComponent(q)}`);
  if (!res.ok) throw new Error("library search failed");
  return res.json();
}

/** Founder preview: slugs in REVIEW status (admin token required). */
export async function fetchReviewSlugs(categoryId, token) {
  const res = await fetch(`${API}/api/admin/library/entries?category=${categoryId}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!res.ok) throw new Error("admin entries failed");
  const data = await res.json();
  const items = Array.isArray(data) ? data : (data.entries || []);
  return items.filter((e) => e.status === "review").map((e) => e.slug);
}

export async function fetchLibraryEntry(categoryId, slug, { preview = false, token = "" } = {}) {
  const url = `${API}/api/library/entries/${categoryId}/${slug}${preview ? "?preview=true" : ""}`;
  const res = await fetch(url, preview ? { headers: { Authorization: `Bearer ${token}` } } : undefined);
  if (!res.ok) throw new Error("library entry failed");
  return res.json();
}

export async function fetchLibraryEntryBySlug(slug, { preview = false, token = "" } = {}) {
  const url = `${API}/api/library/entry/${slug}${preview ? "?preview=true" : ""}`;
  const res = await fetch(url, preview ? { headers: { Authorization: `Bearer ${token}` } } : undefined);
  if (!res.ok) throw new Error("library entry failed");
  return res.json();
}
